import { KEYWORDS } from "../data/site";

export default function Marquee() {
  const row = (key) =>
    KEYWORDS.map((k, i) => (
      <span key={`${key}-${i}`} className="flex items-center shrink-0">
        <span className="font-display font-bold uppercase tracking-[0.14em] text-lg text-white/70 px-6 whitespace-nowrap">
          {k}
        </span>
        <span className="w-2 h-2 bg-amber rotate-45 shrink-0"></span>
      </span>
    ));
  return (
    <div
      className="overflow-hidden border-y border-amber/20 bg-coal/60"
      data-testid="keyword-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track py-4">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
